import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.globalHandlersIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
  ],
  // Tracing
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.api\.lightyx\.com/, // matches dev.api and api
    /^https:\/\/api\.lightyx\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0, // This sets the sample rate at 100%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// const storageCleared = localStorage.getItem('cleared');
// if (storageCleared !== '1') {
//   localStorage.clear()
//   localStorage.setItem('cleared', '1')
// }

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={() => {
        // If the crash is auth-related (token gone), silently send the user to login.
        // sessionStorage flag prevents an infinite loop if `/` itself crashes.
        const authGone = !localStorage.getItem('token');
        const alreadyRedirected = sessionStorage.getItem('errorRedirect');
        if (authGone && !alreadyRedirected) {
          sessionStorage.setItem('errorRedirect', '1');
          localStorage.clear();
          window.location.replace('/');
          return <></>;
        }
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              gap: '1rem',
            }}
          >
            <h1>Oops! Something went wrong</h1>
            <p>We've been notified and are working on it.</p>
            <button
              onClick={() => {
                sessionStorage.removeItem('errorRedirect');
                window.location.replace('/');
              }}
              style={{
                padding: '0.5rem 1rem',
                cursor: 'pointer',
              }}
            >
              Go to login
            </button>
          </div>
        );
      }}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
